// Format names with proper capitalization
// First name and last name capitalized, particles/prepositions lowercase

const particles = ['de', 'van', 'der', 'den', 'het', 'ter', 'ten', 'te', 'la', 'le', 'du', 'da', 'di', 'del', 'dos', 'das', 'von', 'zu', 'af', 'av'];

export const formatDriverName = (name) => {
  if (!name) return '';
  
  return name
    .split(' ')
    .map((word, index) => {
      const lowerWord = word.toLowerCase();
      
      // Check if it's a particle (but not at the start of the name)
      if (index > 0 && particles.includes(lowerWord)) {
        return lowerWord;
      }
      
      // Capitalize first letter, rest lowercase
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

// Format driver name as "LastName, FirstName" for dropdowns and selection
// Example: "Verstappen, Max" or "Hamilton, Lewis"
export const formatDriverNameLastFirst = (driver) => {
  if (!driver) return '';
  
  // If driver is a string (just the name), try to split it
  if (typeof driver === 'string') {
    const parts = driver.trim().split(' ');
    if (parts.length >= 2) {
      const firstName = parts[0];
      const lastName = parts.slice(1).join(' ');
      return `${capitalizeProper(lastName)}, ${capitalizeProper(firstName)}`;
    }
    return capitalizeProper(driver);
  }
  
  // If driver is an object with given_name and family_name
  const firstName = driver.given_name || driver.firstName || '';
  const lastName = driver.family_name || driver.familyName || driver.lastName || '';
  
  if (lastName && firstName) {
    return `${capitalizeProper(lastName)}, ${capitalizeProper(firstName)}`;
  }
  
  // Fallback to name field
  if (driver.name) {
    const parts = driver.name.trim().split(' ');
    if (parts.length >= 2) {
      const fName = parts[0];
      const lName = parts.slice(1).join(' ');
      return `${capitalizeProper(lName)}, ${capitalizeProper(fName)}`;
    }
    return capitalizeProper(driver.name);
  }
  
  return '';
};

// Helper function to properly capitalize a name part
const capitalizeProper = (str) => {
  if (!str) return '';
  
  return str
    .split(' ')
    .map((word, index) => {
      const lowerWord = word.toLowerCase();
      
      // Check if it's a particle (but not at the start)
      if (index > 0 && particles.includes(lowerWord)) {
        return lowerWord;
      }
      
      // Capitalize first letter
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export const formatTeamName = (name) => {
  if (!name) return '';
  
  // Team names are usually all caps or have specific formatting
  // Keep original but ensure proper title case
  return name
    .split(' ')
    .map(word => {
      // Keep acronyms uppercase (2-4 letter words that are all caps)
      if (word.length <= 4 && word === word.toUpperCase()) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export default formatDriverName;
